import { MD5 } from "crypto-js";
import React, { Component } from "react";
// import ChatPlatformInformation from '../ChatPlatformInformation';
import { connect } from 'react-redux'
import "./index.css";
import { store } from "../../store";

// let num = 0;

class ChatOnlinePlatformInit extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fromApp: 'Dropshipman',
            shopOwner: '',
            shopifyDomain: '',
            userEmail: '',
            storeName: '',
            userLevel: 0,
            reviewStar: 'no review',
            shopifyStoreVersion: '',
            createdAt: '',
            lastLogin: '',
            useDays: '',
        };
        
        // 添加标志位，防止组件卸载后继续执行
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;
        this.getInitData();
    }
    
    componentWillUnmount() {
        // 组件卸载时清理标志位
        this._isMounted = false;
    }

    // 获取数据
    getInitData = () => {
        try {
            const languageState = store.getState()?.languageReducer;
            const response = languageState?.subScriptData;

            if (response && Object.keys(response).length > 0) {
                let getData = response;
                // 用户默认语言等
                window.language = getData.language;
                window.S_SHOP_DOMAIN = getData.domain;
                window.S_USER_TOKEN  = getData.session;
                window.S_SHOP_OWNER  = getData.owner;
                window.S_EMAIL       = getData.email;
                window.S_STORE_NAME  = getData.store_name;

                this.setState({
                    shopOwner: getData.owner || '',
                    shopifyDomain: getData.domain || '',
                    userEmail: getData.email || '',
                    storeName: getData.store_name || '',
                    userLevel: getData.level || 0,
                    reviewStar: getData.review || 'no review',
                    shopifyStoreVersion: getData.shopify_level || '',
                    createdAt: getData.created_at || '',
                    useDays: getData.use_days || '',
                    lastLogin: getData.lastlogin_time || '',

                }, () => {
                    // 只在组件挂载时执行
                    if (this._isMounted) {
                        this.ChatOnlineToolInit();
                        this.NpsInit();
                        // 检查 refresh 方法是否存在
                        if (typeof this.props.refresh === 'function') {
                            this.props.refresh();
                        }
                    }
                });

                if (window.__bl && window.__bl.setConfig) {
                    window.__bl.setConfig({
                      setUsername:function(){
                          return getData.domain
                      },
                      uid: getData.domain
                    })
                }
            } else {
                this.setState({
                    name: 'dropshipman_visitor',
                    user_id: 'dropshipman_visitor'
                }, () => {
                    if (this._isMounted) {
                        this.ChatOnlineToolInit();
                    }
                })
            }
        } catch (error) {
            console.warn('getInitData error:', error);
        }
    }

    NpsInit = async () => {
        setTimeout(() => {
            try {
                // 检查组件是否仍然挂载
                if (!this._isMounted) return;
                
                const accessTime = Math.ceil(new Date().getTime() / 1000);
                const accessToken = 'FJMKRGFW1PWYZIZLKHDFQWV5Q01CQGDM6XE432QQ'
                const sign = MD5(accessToken + accessTime).toString();
                const bootData = { 
                    accessType: 'DSMAPP',
                    accessToken: sign,
                    accessTime: accessTime, 
                    shop: this.state.shopifyDomain,
                    planDisplayName: this.state.shopifyStoreVersion,
                    days: this.state.useDays,
                    installTime: this.state.createdAt,
                    language: window.language == null ? 'en' : window.language,
                    attribute: 'In-product.Pop-up.Dashboard',
                    lastTime: this.state.lastLogin,
                    // 样式可以写在这里
                    style: {}
                  }

                //   console.log(bootData)

                if (Object.prototype.toString.call(window.NPS)  === '[object Object]') {
                    // 确保在DOM加载完成后再执行
                    if (document.readyState === 'complete') {
                        window.NPS.boot(bootData)
                    } else {
                        window.addEventListener('load', () => {
                            if (this._isMounted && window.NPS) {
                                window.NPS.boot(bootData)
                            }
                        })
                    }
                } else {
                    let load = (window.NPSLoad = false)
                    const self = this;
                    Object.defineProperty(window, 'NPSLoad', {
                        get() {
                            return load
                        },
                        set(newVal) {
                            load = newVal
                            if (newVal && self._isMounted) {
                                window.NPS.boot(bootData)
                            }
                            return load
                        },
                    })
                }

            } catch (error) {
                console.warn('NpsInit error:', error);
            }
        }, 1000);
    }

    // 初始化聊天工具
    ChatOnlineToolInit = async () => {
            try {
                // 检查组件是否仍然挂载
                if (!this._isMounted) return;
                
                let visitorNo = new Date().getTime() + Math.ceil(Math.random()*1000);
                
                const bootConfig = {
                    user_name: this.state.shopOwner !== '' ? this.state.shopOwner : 'dropshipman_visitor',
                    user_email: this.state.userEmail !== '' ? this.state.userEmail : 'dropshipman_visitor',
                    user_id: 'dropshipman_' + (this.state.shopifyDomain || 'visitor'),
                    fromApp: this.state.fromApp,
                    shopUrl: this.state.shopifyDomain !== '' ? this.state.shopifyDomain : 'dropshipman_visitor_' + visitorNo,
                    // Usersname: this.state.storeName !== '' ? this.state.storeName : '',
                    shopifyPlan: this.state.shopifyStoreVersion,
                    plan: this.state.userLevel,
                    reviewName: this.state.storeName ? this.state.storeName : 'no review_name',
                    review: this.state.reviewStar,
                    first_name: this.state.storeName,
                };
                
                if (typeof window.Willdesk == 'object' && window.Willdesk.boot) {
                    // 确保在DOM加载完成后再执行
                    if (document.readyState === 'complete') {
                        window.Willdesk.boot(bootConfig)
                    } else {
                        window.addEventListener('load', () => {
                            if (this._isMounted && window.Willdesk) {
                                window.Willdesk.boot(bootConfig)
                            }
                        })
                    }
                  } else {
                      let load = window.WilldeskLoad = false
                      const self = this;
                      Object.defineProperty(window, 'WilldeskLoad', {
                      get () { return load },
                      set(newVal) {
                        load = newVal
                        if (newVal && self._isMounted) { 
                            window.Willdesk.boot(bootConfig)
                        }
                        return load
                      }
                    })
                  }
                
                // console.log(window.Willdesk.boot());
                // window.Intercom('boot', {
                //     app_id: 't6tndyrj',
                //     from_app: this.state.fromApp,
                    
                //     name: this.state.shopOwner !== '' ? this.state.shopOwner : 'dropshipman_visitor',
                //     email: this.state.userEmail !== '' ? this.state.userEmail : 'dropshipman_visitor',
                //     user_id: 'dropshipman_' + this.state.shopifyDomain,
                //     shop_name: this.state.shopifyDomain !== '' ? this.state.shopifyDomain : 'dropshipman_visitor_' + visitorNo,
                //     Usersname: this.state.storeName !== '' ? this.state.storeName : '',
                //     shopify_store_version: this.state.shopifyStoreVersion,
                //     plan: this.state.userLevel,
                //     review_name: this.state.storeName ? this.state.storeName : 'no review_name',
                //     review: this.state.reviewStar,
                // });

                // window.Intercom('hide');

                // window.Intercom('onUnreadCountChange', function (unreadCount) {
                //     num += 1;
                //     // 首次进入 一般都是页面刷新后初始化平台成功之后进入
                //     if(num === 1) {
                //         if(window.location.pathname === "/admin/dashboard") {
                //             setTimeout(() => {
                //                 document.getElementsByClassName('intercom-duq38k')[0].style.display = "block"
                //             },500);
                //         }
                //     } else {
                //         document.getElementsByClassName('intercom-duq38k')[0].style.display = "none"
                //     }
                // })

            } catch (error) {
                console.warn('ChatOnlineToolInit error:', error);
            }

    }

    // // 初始化聊天工具
    // ChatOnlineToolInit = async () => {
    //     setTimeout(() => {
    //         try {
    //             let visitorNo = new Date().getTime() + Math.ceil(Math.random()*1000);
                
    //             window.Intercom('boot', {
    //                 app_id: 't6tndyrj',
    //                 from_app: this.state.fromApp,
                    
    //                 name: this.state.shopOwner !== '' ? this.state.shopOwner : 'dropshipman_visitor',
    //                 email: this.state.userEmail !== '' ? this.state.userEmail : 'dropshipman_visitor',
    //                 user_id: 'dropshipman_' + this.state.shopifyDomain,
    //                 shop_name: this.state.shopifyDomain !== '' ? this.state.shopifyDomain : 'dropshipman_visitor_' + visitorNo,
    //                 Usersname: this.state.storeName !== '' ? this.state.storeName : '',
    //                 shopify_store_version: this.state.shopifyStoreVersion,
    //                 plan: this.state.userLevel,
    //                 review_name: this.state.storeName ? this.state.storeName : 'no review_name',
    //                 review: this.state.reviewStar,
    //             });

    //             window.Intercom('hide');

    //             window.Intercom('onUnreadCountChange', function (unreadCount) {
    //                 num += 1;
    //                 // 首次进入 一般都是页面刷新后初始化平台成功之后进入
    //                 if(num === 1) {
    //                     if(window.location.pathname === "/admin/dashboard") {
    //                         setTimeout(() => {
    //                             document.getElementsByClassName('intercom-duq38k')[0].style.display = "block"
    //                         },500);
    //                     }
    //                 } else {
    //                     document.getElementsByClassName('intercom-duq38k')[0].style.display = "none"
    //                 }
    //             })

    //         } catch (error) {
    //             console.warn(error);
    //         }

    //     }, 1000);
    // }

    render() {
        // const { fromApp, shopOwner } = this.state;

        return (
            <></>
            // <ChatPlatformInformation from_app={fromApp} name={shopOwner} />
        )
    }
}

export default connect()(ChatOnlinePlatformInit);